<div
  class="car-and-dealer"
  [ngStyle]="{ 'background-image': hero ? 'url(' + hero + ')' : '' }"
>
  <div class="container-fluid">
    <div class="text-container">
      <div class="row">
        <div class="mx-auto col-xl-6 col-12">
          <h1>
            <span class="h1 d-block">{{ caption }}</span>
            <span class="h1 mb-0 subtitle">{{ ingress }}</span>
          </h1>
        </div>
      </div>

      <div
        class="row my-4"
        *ngIf="
          (channelRequestService.channelRequest &&
            channelRequestService.channelRequest.shoppingCart &&
            channelRequestService.channelRequest.shoppingCart.vehicle) ||
          modelAndDealerService.selectedDealer
        "
      >
        <div class="mx-auto col-xl-6 col-12">
          <div class="row">
            <div class="col-12 col-xl-8 choise-info">
              <span
                *ngIf="
                  channelRequestService.channelRequest &&
                  channelRequestService.channelRequest.shoppingCart &&
                  channelRequestService.channelRequest.shoppingCart.vehicle &&
                  !modelAndDealerService.selectedDealer
                "
                class="color-white"
                [innerHTML]="
                  'carAndDealer.vehicleSelected'
                    | translate
                      : {
                          vehicleName:
                            channelRequestService.channelRequest.shoppingCart
                              .vehicle | vehicle,
                        }
                "
              >
              </span>

              <span
                *ngIf="
                  channelRequestService.channelRequest &&
                  channelRequestService.channelRequest.shoppingCart &&
                  channelRequestService.channelRequest.shoppingCart.vehicle &&
                  modelAndDealerService.selectedDealer
                "
                class="color-white"
                [innerHTML]="
                  'carAndDealer.vehicleAndDealerSelected'
                    | translate
                      : {
                          vehicleName:
                            channelRequestService.channelRequest.shoppingCart
                              .vehicle | vehicle,
                          dealerName: modelAndDealerService.selectedDealer.name,
                          dealerCity: modelAndDealerService.selectedDealer.city,
                        }
                "
              >
              </span>

              <span
                *ngIf="
                  (!channelRequestService.channelRequest ||
                    !channelRequestService.channelRequest.shoppingCart ||
                    !channelRequestService.channelRequest.shoppingCart
                      .vehicle) &&
                  modelAndDealerService.selectedDealer
                "
                class="color-white"
                [innerHTML]="
                  'carAndDealer.dealerSelected'
                    | translate
                      : {
                          dealerName: modelAndDealerService.selectedDealer.name,
                          dealerCity: modelAndDealerService.selectedDealer.city,
                        }
                "
              >
              </span>

              <span
                class="color-white d-block mt-2"
                *ngIf="
                  channelRequestService.channelRequest &&
                  channelRequestService.channelRequest.shoppingCart &&
                  channelRequestService.channelRequest.shoppingCart.vehicle &&
                  modelAndDealerService.selectedDealer
                "
                (click)="openSelectDealerModal()"
              >
                <u class="pointer">{{ "changeRegNrOrDealer" | translate }}</u>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container
      *ngIf="
        !channelRequestService.channelRequest ||
        !channelRequestService.channelRequest.shoppingCart ||
        !channelRequestService.channelRequest.shoppingCart.vehicle ||
        !modelAndDealerService.selectedDealer
      "
    >
      <div class="input-container mt-4">
        <div class="row" *ngIf="!filterByModel">
          <div class="col-xl-3 offset-xl-3 col-md-5 col-12 me-3">
            <form
              [formGroup]="regNrForm"
              autocomplete="off"
              (ngSubmit)="updateVehicle()"
            >
              <vw-text-box
                [id]="'reg-nr'"
                [label]="'carAndDealer.enterRegistrationNumber' | translate"
                [type]="'text'"
                [parentForm]="regNrForm"
                [placeholder]="'carAndDealer.regNrPlaceholder' | translate"
                [labelClass]="'fw-light'"
                [formControlProp]="'regNr'"
                [buttonText]="'select' | translate"
                (clear$)="clearRegNr()"
                (buttonClick$)="updateVehicle()"
                [buttonDisabled]="!regNrForm.controls.regNr.valid"
                [loading]="updateVehicleSaving"
              >
                <div class="filter-by-model">
                  <span
                    class="pointer d-flex align-items-center"
                    (click)="toggleFilterByModel()"
                  >
                    <i class="fal fa-filter me-1"></i>
                    {{ "carAndDealer.filterByModel" | translate }}
                  </span>
                </div>
              </vw-text-box>
            </form>
          </div>

          <div class="col-xl-3 col-md-5 col-12">
            <form [formGroup]="dealerForm" autocomplete="off">
              <vw-typeahead
                [id]="'dealer'"
                [label]="'carAndDealer.findDealer' | translate"
                [labelClass]="'fw-light'"
                [buttonText]="'select' | translate"
                [parentForm]="dealerForm"
                [formControlProp]="'dealer'"
                [items]="
                  dealerForm.value.dealer
                    ? (modelAndDealerService.dealers | callback: filterDealer)
                    : modelAndDealerService.dealers
                "
                [template]="dealerTemplate"
                [placeholder]="'carAndDealer.dealerPlaceholder' | translate"
                (itemSelected$)="selectDealer($event)"
                [open]="
                  !dealerForm.value.selectedDealerId &&
                  !!dealerForm.value.dealer
                "
                [loading]="updateDealerSaving"
                [showMapToggle]="true"
                [noMatchesTranslationKey]="'carAndDealer.dealerNoMatches'"
                (buttonClick$)="updateDealer()"
                [buttonDisabled]="!dealerForm.controls.selectedDealerId.value"
              >
                <span
                  (click)="openSelectDealerModal()"
                  class="pointer show-map d-flex align-items-center"
                >
                  <i class="fal fa-map-marker-alt me-1"></i>
                  {{ "carAndDealer.showMap" | translate }}
                </span>
              </vw-typeahead>
            </form>
          </div>
        </div>
      </div>
    </ng-container>
    <form
      [formGroup]="searchForm"
      autocomplete="off"
      *ngIf="
        channelRequestService.channelRequest &&
        channelRequestService.channelRequest.shoppingCart &&
        channelRequestService.channelRequest.shoppingCart.vehicle &&
        modelAndDealerService.selectedDealer
      "
      (ngSubmit)="searchSubmit()"
    >
      <div class="input-container mt-4">
        <div class="row">
          <div class="col-xl-3 offset-xl-3 col-md-5 col-12">
            <vw-text-box
              [id]="'search-accessories'"
              [label]="'carAndDealer.searchAccessories' | translate"
              [type]="'text'"
              [parentForm]="searchForm"
              [formControlProp]="'query'"
              [labelClass]="'fw-light'"
              [placeholder]="'carAndDealer.accessoriesPlaceholder' | translate"
            >
            </vw-text-box>
          </div>
        </div>
      </div>
    </form>
  </div>

  <form
    [formGroup]="modelAndDealerService.modelForm"
    autocomplete="off"
    *ngIf="filterByModel"
  >
    <div class="filter-by-model-container">
      <div class="container-fluid">
        <div class="row">
          <div class="offset-xl-1 col-xl-11 col-12">
            <div
              class="header d-flex justify-content-between align-items-center"
            >
              <h4>{{ "carAndDealer.filterByModel" | translate }}</h4>

              <div
                class="d-flex align-items-center pointer"
                (click)="toggleFilterByModel()"
              >
                <span class="me-3 color-white">{{ "close" | translate }}</span>
                <i class="fal fa-times"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-end">
          <div class="offset-xl-1 col-md-3 col-12">
            <vw-select
              [id]="'model-group'"
              [label]="'carAndDealer.modelGroup' | translate"
              [items]="modelAndDealerService.modelGroups"
              [template]="modelGroupTemplate"
              [parentForm]="modelAndDealerService.modelForm"
              [formControlProp]="'modelGroupId'"
              [emptyOption]="true"
            ></vw-select>
          </div>

          <div class="col-md-3 col-12">
            <vw-select
              [id]="'year'"
              [label]="'carAndDealer.year' | translate"
              [items]="modelAndDealerService.years"
              [template]="yearTemplate"
              [parentForm]="modelAndDealerService.modelForm"
              [formControlProp]="'year'"
              [emptyOption]="true"
            ></vw-select>
          </div>

          <div class="col-md-3 col-12">
            <vw-select
              [id]="'model'"
              [label]="'carAndDealer.model' | translate"
              [items]="modelAndDealerService.models"
              [template]="modelTemplate"
              [parentForm]="modelAndDealerService.modelForm"
              [formControlProp]="'model'"
              [emptyOption]="true"
            ></vw-select>
          </div>

          <div class="col-xl-2 col-md-3 col-12">
            <vw-button
              [type]="'button'"
              [primary]="true"
              [text]="'carAndDealer.findTheCar' | translate"
              (click$)="modelSelected()"
              [disabled]="
                !modelAndDealerService.modelForm.valid || updateVehicleSaving
              "
              [large]="true"
            ></vw-button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-template #dealerTemplate let-item="item">
    <div class="dealer-template">
      <i class="fal fa-map-marker-alt"></i>
      <div>
        <span
          [innerHTML]="item.name | highlight: dealerForm.value.dealer ?? ''"
        >
        </span>
        <span class="city">{{ item.postalCode + ", " + item.city }}</span>
      </div>
    </div>
  </ng-template>

  <ng-template #yearTemplate let-item="item">
    <option [value]="item">
      {{ item }}
    </option>
  </ng-template>

  <ng-template #modelGroupTemplate let-item="item">
    <option [value]="item.modelGroupId">
      {{ item.name | titlecase }}
    </option>
  </ng-template>

  <ng-template #modelTemplate let-item="item">
    <option [value]="item.name">{{ item.name }} ({{ item.modelCode }})</option>
  </ng-template>
</div>
